function reducer(state = [], action) {
    switch (action.type) {
        case 'CAMPAIGN/SET':
            return action.campaign;
        default:
            return state;
    }
}

export default reducer;
